module.exports = __webpack_public_path__ + "static/best-usability-small-business-2022-64d169e794adf86ea5042fd7e9424962.svg";